import React, { PropsWithChildren, useMemo } from 'react';
import { WidgetContextProvider } from './WidgetContext';
import { WidgetType } from '../../../types/api/ElementType';
import { HtmlProps } from '../../../types/HtmlProps';
import { getWidgetFrameId } from './Widget.utils';

type WidgetProps = PropsWithChildren<{
  uuid: string;
  widgetType: WidgetType;
  isArticle?: boolean;
  header?: boolean;
  invisible?: boolean;
  isFrameless?: boolean;
}>;

export function Widget({
  uuid,
  children,
  widgetType,
  isFrameless,
  isArticle = false,
  header = false,
  ...sectionProps
}: WidgetProps & HtmlProps) {
  const widgetId = getWidgetFrameId(widgetType, uuid);
  const contextValue = useMemo(
    () => ({
      widgetType,
      widgetId,
      uuid,
      header,
    }),
    [widgetType, widgetId, uuid, header]
  );

  const Element = isArticle ? 'article' : 'section';
  // destruct and dont use invisible, legacy prop from backend we do not use anymore for newer widgets.
  // remove this from json when all sections are moved to new BlockFetcher/Widget mapping
  const { invisible: _, ...widgetProps } = sectionProps;

  const className = ['widget widget__content'];

  if (isFrameless) {
    className.push('widget--frameless');
  }

  return (
    <Element className={className.join(' ')} id={widgetId} {...widgetProps}>
      <div className="widget__rounded-corners-top"></div>
      <WidgetContextProvider value={contextValue}>{children}</WidgetContextProvider>
      <div className="widget__rounded-corners-bottom"></div>
    </Element>
  );
}
